module.exports = __webpack_public_path__ + "img/thumb-005-16.ac4f2764.png";